import { Field } from "./field";
import { cr } from "fire-wind-water/core";
import api from "../services/api";

export class Select extends Field {
  constructor(field) {
    super(field);
    const attr = [
      "listOptionType",
      "listDictId",
      "listLimitType",
      "listOptions",
      "options"
    ];
    cr.each(attr, d => {
      this[d] = field[d];
    });
    this.displaySelectType = "SELECT";
    this.value = null;
    this.model = undefined;
    this.isCascade = 0;
    this.columns = [];
    this.initOptions();
  }

  initOptions() {
    if (this.listOptionType === "DICT") {
      const info = {
        tenantId: this.tenantId,
        dicId: this.listDictId,
        format: "object"
      };
      api.dicParamsGetTree(info).subscribe(data => {
        if (parseInt(data.result) === 0) {
          this.setOptions(data.content[this.listDictId]);
        }
      });
    } else {
      this.setOptions(this.listOptions);
    }
  }

  dealWithAttrValue(data, n) {
    let scope = this;
    if (!this.count || n > this.count) {
      this.count = n;
    }

    if (!this.valueJson[n]) {
      this.valueJson[n] = {};
    }
    cr.each(data, d => {
      d.optionId = d.paramId || d.optionId;
      d.optionValue = d.name || d.optionValue;
      d.value = d.optionValue;
      d.label = d.optionValue;
      d.isLeaf = true;
      d.text = d.optionValue;
      scope.valueJson[n][d.optionValue] = true;
      if (n === 0) {
        scope.columns.push(d.optionValue);
      }
      if (scope.listLimitType === "RADIO") {
        for (let a in d.child) {
          if (d.child[a]) {
            d.child = d.child[a];
            break;
          }
        }
        if (d.child && d.child.length > 0) {
          d.isLeaf = false;
          scope.isCascade = 1;
          scope.dealWithAttrValue(d.child, n + 1);
          d.children = d.child;
        }
      } else {
        scope.isCascade = 0;
      }
    });
  }

  setOptions(data) {
    this.listOptions = data;
    this.columns = [];
    this.valueJson = {};
    this.dealWithAttrValue(this.listOptions, 0);
    if (this.isCascade === 1) {
      this.columns = this.listOptions;
    }
    this.isValueExist();
    this.hasError();
    this.isError();
  }

  // 判断value是否存在
  isValueExist() {
    if (this.isCascade === 1) {
      this.model = this.value ? [...this.value] : [];
    } else {
      this.model = this.value ? this.value[0] : undefined;
    }
    if (!this.value || this.value.length === 0) {
      return;
    }
    if (this.isCascade === 1) {
      for (let i = 0; i < this.value.length; i++) {
        let d = this.value[i];
        if (!this.valueJson[i][d]) {
          this.value.splice(i, this.value.length);
          break;
        }
      }
    } else {
      const arr = [];
      cr.each(this.value, d => {
        if (this.valueJson[0][d]) {
          arr.push(d);
        }
      });
      this.value = arr;
    }
  }

  setValue() {
    if (this.isCascade === 1) {
      this.value = this.model ? [...this.model] : [];
    } else {
      this.value = this.model ? [this.model] : null;
    }
    this.dirty = true;
    this.hasError();
    this.isError();
  }

  initValue(val) {
    this.setModel(val);
    this.dirty = false;
  }

  setModel(e) {
    this.model = e;
    this.value = e;
    this.dirty = true;
    this.hasError();
    this.isError();
  }

  clearModel() {
    this.model = undefined;
    this.value = null;
    this.dirty = true;
    this.hasError();
    this.isError();
  }
  hasError() {
    this.setError();
    if (
      (!this.value || this.value.length === 0) &&
      parseInt(this.required) === 1
    ) {
      this.error.required = true;
    }
  }
}
